var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWeight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 55,
    viewBox: "0 0 45 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36 13H9C5.68629 13 3 15.6863 3 19V46C3 49.3137 5.68629 52 9 52H36C39.3137 52 42 49.3137 42 46V19C42 15.6863 39.3137 13 36 13ZM9 10C4.02944 10 0 14.0294 0 19V46C0 50.9706 4.02944 55 9 55H36C40.9706 55 45 50.9706 45 46V19C45 14.0294 40.9706 10 36 10H9Z",
    fill: "url(#paint0_linear_7305_1490)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36 13H9C5.68629 13 3 15.6863 3 19V46C3 49.3137 5.68629 52 9 52H36C39.3137 52 42 49.3137 42 46V19C42 15.6863 39.3137 13 36 13ZM9 10C4.02944 10 0 14.0294 0 19V46C0 50.9706 4.02944 55 9 55H36C40.9706 55 45 50.9706 45 46V19C45 14.0294 40.9706 10 36 10H9Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33 10C33 15.5228 28.5228 20 23 20C17.4772 20 13 15.5228 13 10C13 4.47715 17.4772 0 23 0C28.5228 0 33 4.47715 33 10Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 17C26.866 17 30 13.866 30 10C30 6.13401 26.866 3 23 3C19.134 3 16 6.13401 16 10C16 13.866 19.134 17 23 17ZM23 20C28.5228 20 33 15.5228 33 10C33 4.47715 28.5228 0 23 0C17.4772 0 13 4.47715 13 10C13 15.5228 17.4772 20 23 20Z",
    fill: "url(#paint1_linear_7305_1490)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 17C26.866 17 30 13.866 30 10C30 6.13401 26.866 3 23 3C19.134 3 16 6.13401 16 10C16 13.866 19.134 17 23 17ZM23 20C28.5228 20 33 15.5228 33 10C33 4.47715 28.5228 0 23 0C17.4772 0 13 4.47715 13 10C13 15.5228 17.4772 20 23 20Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 12C21.8954 12 21 11.1046 21 10L21 7C21 5.89543 21.8954 5 23 5C24.1046 5 25 5.89543 25 7L25 10C25 11.1046 24.1046 12 23 12Z",
    fill: "url(#paint2_linear_7305_1490)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 12C21.8954 12 21 11.1046 21 10L21 7C21 5.89543 21.8954 5 23 5C24.1046 5 25 5.89543 25 7L25 10C25 11.1046 24.1046 12 23 12Z",
    fill: "black",
    fillOpacity: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7305_1490",
    x1: 8.77119,
    y1: 16.4831,
    x2: 37.3729,
    y2: 46.9915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4061A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A98D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7305_1490",
    x1: 16.8983,
    y1: 2.88136,
    x2: 29.6102,
    y2: 16.4407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4061A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A98D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7305_1490",
    x1: 21.5763,
    y1: 10.6356,
    x2: 25.5354,
    y2: 8.51464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4061A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A98D1"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeight);
export default __webpack_public_path__ + "static/media/weight.f54277ba1a555633f7f8aba0e4384d17.svg";
export { ForwardRef as ReactComponent };